import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

const initialState = {
  email: null,
  password: null,
  loading: false,
  hasErrors: false,
  userToken: null,
  isFetching: false,
  isSuccess: false,
  isError: false,
}

interface registerloginfield {
  email: string
  password: string
}

export const loginUser: any = createAsyncThunk(
  'user/login',
  async (payload: registerloginfield, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }
      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}user/login/`, payload)
      localStorage.setItem('userToken', data.token)
      localStorage.setItem('userVerify', data.user.is_acc_verified)
      return data
    } catch (error: any) {
      if (error.response.status === 400) {
        return rejectWithValue(error.response)
      }
      return rejectWithValue(error.message)
    }
  }
)

export const userLoginSlice = createSlice({
  name: 'userloginslice',
  initialState,
  reducers: {},

  extraReducers: {
    [loginUser.fulfilled]: (state, action) => {
      return {
        user: action.payload,
        loading: 'success',
        hasErrors: null,
      }
    },
    [loginUser.pending]: (state, action) => {
      state.loading = true
      state.hasErrors = false
    },
    [loginUser.rejected]: (state, action) => {
      state.isFetching = false
      state.isError = true
    },
  },
})
export default userLoginSlice.reducer
export const userSelector = (state) => state.authUserLogin
